module.exports = __webpack_public_path__ + "static/media/download_bold_white.5a24827a.svg";